export default __webpack_public_path__ + "static/media/s-banner.40734fb8.png";